const mediaItems = [
  {
    title: '《流浪地球3》',
    desc: '国产科幻巨制第三部曲，人类文明的终极抉择，视觉震撼前所未有',
    tag: '科幻大片',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20space%20scene%20with%20giant%20planet%20and%20spaceship%2C%20dramatic%20lighting%2C%20dark%20blue%20and%20golden%20color%20scheme%2C%20epic%20atmosphere%2C%20movie%20poster%20aesthetic%2C%20no%20text%2C%20no%20people%2C%20artistic%20rendering&width=800&height=450&seq=media-card-01&orientation=landscape',
  },
  {
    title: '《盗梦空间》',
    desc: '诺兰经典科幻悬疑，层层嵌套的梦境迷宫，烧脑程度再升级',
    tag: '悬疑经典',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20cityscape%20folding%20inward%20with%20surreal%20geometry%2C%20dreamlike%20atmosphere%2C%20muted%20blue%20gray%20tones%20with%20warm%20golden%20highlights%2C%20cinematic%20wide%20shot%2C%20mind%20bending%20visual%2C%20no%20text%2C%20no%20people%2C%20atmospheric&width=800&height=450&seq=media-card-02&orientation=landscape',
  },
  {
    title: '《甄嬛传》',
    desc: '宫斗剧巅峰之作完整收录，76集全高清画质，经典不容错过',
    tag: '古装经典',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20palace%20interior%20with%20warm%20candlelight%2C%20ornate%20red%20and%20gold%20decorations%2C%20traditional%20silk%20curtains%2C%20imperial%20furniture%2C%20soft%20atmospheric%20lighting%2C%20historical%20drama%20aesthetic%2C%20no%20text%2C%20no%20people&width=800&height=450&seq=media-card-03&orientation=landscape',
  },
  {
    title: '《海贼王》',
    desc: '热血航海冒险连载更新，路飞五档觉醒篇全高清上线',
    tag: '热血动漫',
    img: 'https://readdy.ai/api/search-image?query=Vast%20ocean%20with%20dramatic%20sunset%20sky%2C%20sailing%20ship%20silhouette%20on%20horizon%2C%20golden%20waves%2C%20adventure%20atmosphere%2C%20epic%20cinematic%20wide%20shot%2C%20warm%20amber%20and%20deep%20blue%20tones%2C%20no%20text%2C%20no%20people&width=800&height=450&seq=media-card-04&orientation=landscape',
  },
  {
    title: '《唐人街探案4》',
    desc: '搞笑推理系列最新作，唐仁秦风再度联手破奇案',
    tag: '喜剧推理',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20neon%20lit%20city%20street%20at%20night%2C%20colorful%20signs%2C%20mystery%20noir%20atmosphere%2C%20modern%20urban%20scene%2C%20dark%20alley%20with%20warm%20street%20lamp%20glow%2C%20cinematic%20composition%2C%20no%20text%2C%20no%20people&width=800&height=450&seq=media-card-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">精选影片</h2>
          <p className="text-sm text-foreground-500">高分佳作一网打尽，高清画质流畅观影体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <a
              key={i}
              href="#media"
              className="group rounded-lg overflow-hidden border border-background-200/40 bg-background-100 hover:border-primary-500/30 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 rounded text-xs font-medium bg-primary-500/90 text-background-50">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base text-foreground-100 group-hover:text-primary-400 transition-colors mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}